module.exports = __webpack_public_path__ + "static/media/spinner.c116c4fc.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/spinner.svg
 ** module id = 444
 ** module chunks = 0
 **/